module.exports = __webpack_public_path__ + "img/one.b0c62651.svg";